import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import '../../components/layouts/content2/style.css';
import { useTranslation } from 'react-i18next';
import HomeScreen from './home';
import BuffetScreen from './buffet';
import CumpleScreen from './cumple';


function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);

    const [showHome, setShowHome] = useState(false);
    const [showBuffet, setShowBuffet] = useState(false);
    const [showCumple, setShowCumple] = useState(false);

    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [dataFood, setDataFood] = useState(false);
    
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);



      useEffect(() => {
              menus.map((item) => {
                  if (item.id === 435) {
                  setDataFood(item);
                  }
             
             
              });
      }, [menus]);
    
    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowHome(false)
             getInitData()

        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);



    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };


    return (
       
        
        <div style={{width: '100%', height: '100%'}}>
             <div className='backgroundlayout' style={{width: '100%', height: '100vh', backgroundSize: 'cover', display: 'flex', flexDirection: 'column'}}>

                <div onClick={() => setShowHome(true)} style={{flex: 1, display: 'flex', minHeight: 0}}>

                    <img
                            onContextMenu={(e) => e.preventDefault()}
                            src={require('./assets/SAN-VALENTIN-TABLET.png.png')}
                            loop autoPlay={true} muted
                            style={{
                                marginTop: 20,
                                width: '100%',
                                 pointerEvents: 'none',
                                height: '100%',
                                maxHeight: 760,
                                objectFit: 'contain',



                            }}
                    />
               </div>

                <div style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: 20,
                    paddingBottom: 40,
                    position: 'relative',
                    zIndex: 2
                }}>
                    <div
                        onClick={() => setShowHome(true)}
                        style={{
                            width: 260,
                            height: 60,
                            backgroundColor: '#217ED3',
                            borderRadius: 92,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexDirection: 'row',
                            boxSizing: 'border-box',
                            cursor: 'pointer'
                        }}>
                        <p style={{color: 'white', fontWeight: 'bold', fontSize: 24, fontFamily: 'Arial', textTransform: 'uppercase'}}>
                            {langEng ? 'See Menu' : 'Ver Menú'}
                        </p>
                    </div>
                </div>


            </div>

            {showBuffet && <BuffetScreen setShowBuffet={setShowBuffet} />}
            {showCumple && <CumpleScreen setShowBuffet={setShowCumple} />}
            {showHome && <HomeScreen setShowBar={setShowBar} />}
           </div>
          
           
    );
}

export default Index;